import times from 'lowscore/times.js'

function multiply (n, type) {
  return times(n, () => {
    return {type: type}
  })
}

export default function (adults, children, options) {
  var passengers = multiply(adults, 'adult').concat(multiply(children, 'child'))
  Object.keys(options || {}).forEach(k => {
    passengers.forEach(p => (p[k] = options[k]))
  })
  return passengers
}
